// ============================================================
// Hero.js - Big banner at the top of the page
// ============================================================

import { HERO_BG } from "../data";

function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero-bg-wrapper">
        <div className="hero-bg-img" style={{ backgroundImage: `url(${HERO_BG})` }}></div>
      </div>

      <div className="hero-content">
        <h2>
          Welcome to
          <span className="hero-brand" style={{ color: '#ff2c2c', display: 'block', fontSize: '1.2em' }}>WHANI</span>
        </h2>
        <p className="hero-tagline" style={{ fontWeight: '700' }}>We Help Andaman & Nicobar Islands</p>
        <p className="hero-subtags" style={{ color: '#e0e8ff' }}>
          Infrastructure • Logistics • Safety • Manpower • Community
        </p>

        {/* Buttons */}
        <div className="hero-buttons">
          <a href="#our-services" className="btn-primary" style={{ padding: '14px 36px', borderRadius: '4px', background: '#1d35f0' }}>
            Our Services
          </a>
          <a href="#contact" className="btn-primary" style={{ padding: '14px 36px', borderRadius: '4px', background: '#1d35f0' }}>
            Contact us
          </a>
        </div>
      </div>
    </section>
  );
}

export default Hero;
